import { useB3Lang } from '@b3/lang';

interface PaymentMethodProps {
  code: string;
  fallback?: string;
}

export default function PaymentMethod({ code, fallback }: PaymentMethodProps) {
  const b3Lang = useB3Lang();
  const label = b3Lang(`paymentMethod.${code}`) || fallback || code;
  return <span>{label}</span>;
}